export const defaultFontNames = {
  headerFont: 'Reckless',
  bodyFont: 'Open Sans',
}

export default {
  primary: "'Open Sans', sans-serif",
  header: 'Reckless',
  materialIcons: 'Material Icons',
  materialIconsOutlined: 'Material Icons Outlined',
  materialSymbols: 'Material Symbols',
  materialSymbolsOutlined: 'Material Symbols Outlined',
}
